import { Avatar as MuiAvatar, AvatarProps, IconButton } from '@mui/material';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
type Props = AvatarProps & { initial?: string; src?: string };
const Avatar: FunctionComponent<Props> = ({ className, initial, src }) => {
  return (
    <IconButton component="span">
      <MuiAvatar
        variant='circular'
        className={clsx('avatar', className, src && 'avatar--photo')}
        src={src || undefined}
        imgProps={{ referrerPolicy: 'no-referrer' }}
      >
        {initial}
      </MuiAvatar>
    </IconButton>
  );
};
export default Avatar;
